import XLSFileUpload from "../../FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../styles/vendors/style";
import React, { useEffect, useRef, useState } from "react";
import Stepper1 from "../../components/Stepper";
import Header from "../../components/Header";
import PageLoading from "../../components/PageLoading";
import DupontButton from "../../components/DupontButton";
import { getLastFileDetails } from "../../network/cipAPI";
import {
  storeCostInformation,
  storeDefaultInformation,
  storePlantDetails,
  storeUnits,
  storeApp,
  storeFileId,
} from "../../Store/TemplateStore/template.action";
import Footer from "../../common/footer/Footer";
import { useTranslation } from "react-i18next";
import { Language_Currency_Mapping } from "./Settings/settingsOptions.config";
import LifetimeAdvisorHome from "../lifetimeAdvisorHome";
import {
  getFormattedDate,
  extractPlantId,
  getSelectedPlantTrainInfo,
} from "../../utils/Utils";
import { API_URLS } from "../../network/appUrls";
import "./index.scss";

const steps = (t) => [
  t("stepper.systemInformation"),
  t("stepper.identifyCIP"),
  t("stepper.cleaningEffectiveness"),
  t("stepper.fouling"),
  t("stepper.predict"),
];
const RoAdvisorHome = (props) => {
  const { t, i18n } = useTranslation();
  const {
    plantData,
    token,
  } = useSelector((state) => state);

  const [activeStep, setActiveStep] = useState(0);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const xlmRef = useRef(null);
  const hasLoaded = useRef(false);
  const renamingText =
    activeStep === 4
      ? t("appHome.roReplacementAdvisor")
      : t("ValueStrings.next");
  const handleNext = () => {
    setIsBackClicked(false);
    if (xlmRef && xlmRef.current && (activeStep === 0 || activeStep === 1)) {
      xlmRef.current.onNextClicked();
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(false);
  const [fileDetailsLoaded, setFileDetailsLoaded] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);
  const [settingsButton, setSettingsButton] = useState(null);

  const handleBack = () => {
    setIsBackClicked(true);
    if (activeStep - 1 >= 0) setActiveStep(activeStep - 1);
  };
  //const isLocalhost = window.location.hostname === "localhost";
  //const basePath = isLocalhost ? "/" : "/roadvisor/";
  //const basePath = isLocalhost ? "/" : window.location.origin;
  const basePath = API_URLS.basePath;

  const plantId = extractPlantId();

  const dispatch = useDispatch();

  useEffect(() => {
    if (token && plantData.length > 0 && !hasLoaded.current) {
      hasLoaded.current = true;
      dispatch(storeApp("ca"));
      getLastFileDetail();
    }
  }, [token, plantData]);

  const getLastFileDetail = async () => {
    try {
      const trainToUse = getSelectedPlantTrainInfo(plantData, plantId);
      const fileDetails = await getLastFileDetails(trainToUse);
      //i18n.changeLanguage(fileDetails.data?.lang);
      if (fileDetails && fileDetails?.data) {
        setIsFirstTimeLoad(true);
        const data = fileDetails.data;
        const {
          owner_name,
          city,
          country,
          name,
          water_type,
          num_trains,
          tol_num_elements,
          sel_pass,
          sel_stage,
          sel_pressure_vessels,
          sel_element_involved,
          file,
          sel_element_type,
          is_dupont_element,
          cost: costInfo,
          default_cip: defaultInfo,
          setting: settings,
        } = data;
        const plantInformation = {
          plantLocation: `${city ? ` ${city}, ${country}` : `${country}`}`,
          plantName: name,
          water_type,
          num_trains,
          tol_num_elements,
          sel_train: trainToUse,
          sel_pass,
          sel_stage,
          sel_pressure_vessels,
          sel_element_involved,
          dataset_name: `${owner_name}_${name}_${
            water_type
          }_${getFormattedDate(file?.min_date)} to ${getFormattedDate(
            file?.max_date,
          )}`,
          sel_element_type,
          is_dupont_element: is_dupont_element ? "No" : "Yes",
        };
        dispatch(storePlantDetails(plantInformation));

        const constInformation = {
          energyPrice: costInfo?.energy_price,
          acidPrice: costInfo?.acid_price,
          alkaliPrice: costInfo?.alkali_price,
          waterPrice: costInfo?.water_price,
          costofDownTime: costInfo?.downtime_cost,
          additional_chemical_price: costInfo?.additional_chemical_price,
        };
        dispatch(storeCostInformation(constInformation));
        const defaultInformation = {
          acid_used_per_cip: defaultInfo?.acid_used_per_cip,
          alkali_used_per_cip: defaultInfo?.alkali_used_per_cip,
          additional_chemical_per_cip: defaultInfo?.additional_chemical_per_cip,

          acid_cip_ph: defaultInfo?.acid_cip_ph,
          alkali_cip_ph: defaultInfo?.alkali_cip_ph,
          cip_solution_ph: defaultInfo?.cip_solution_ph,

          acid_cip_temp: defaultInfo?.acid_cip_temp,
          alkali_cip_temp: defaultInfo?.alkali_cip_temp,
          cip_solution_temp: defaultInfo?.cip_solution_temp,

          acid_cip_duration: defaultInfo?.acid_cip_duration,
          alkali_cip_duration: defaultInfo?.alkali_cip_duration,
          cip_solution_duration: defaultInfo?.cip_solution_duration,
        };
        dispatch(storeDefaultInformation(defaultInformation));

        if (file?.file_id) {
          dispatch(
            storeFileId({
              file_id: file.file_id,
            }),
          );
        }

        const unitInformation = {
          temperature: settings?.temperature,
          permeate_quality: settings?.permeate_quality,
          feed_quality: settings?.feed_quality,
          pressure: settings?.pressure,
          flow: settings?.flow,
          flux: settings?.flux,
          volume: settings?.volume,
          mass: settings?.mass,
          currency:
            settings?.currency ||
            parseFloat(Language_Currency_Mapping(i18n.language).currency),
          conversion_rate:
            settings?.conversion_rate ||
            parseFloat(
              Language_Currency_Mapping(i18n.language).conversion_rate,
            ),
          feed_water_permeate_factor: settings?.feed_water_permeate_factor,
          feed_water_factor: settings?.feed_water_factor,
        };
        dispatch(storeUnits(unitInformation));
        setTimeout(() => {
          setIsFirstTimeLoad(false);
        }, 1000);
      }
    } catch (err) {
      console.log("Error " + err);
    } finally {
      setFileDetailsLoaded(true);
    }
  };

  return (
    <>
      {activeStep !== 5 && (
        <div className="container-main">
          <Header activeStep={activeStep} />
          {/* {activeStep === 0 && (
          <div>
            {" "}
            <Welcome
              message={t("welcomeString.cleaningAdvisorIntroduction")}
            ></Welcome>
          </div>
        )} */}
          <div className="main-container">
            <div className="content-container">
              <Stepper1
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleBack={handleBack}
                handleNext={handleNext}
                steps={steps}
                renamingText={renamingText}
                disableNextButton={disableNextButton}
              />
              {fileDetailsLoaded ? (
                <div>
                  <XLSFileUpload
                    ref={xlmRef}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    isFirstTimeLoad={isFirstTimeLoad}
                    isBackClicked={isBackClicked}
                    setIsBackClicked={setIsBackClicked}
                    setDisableNextButton={setDisableNextButton}
                    setSettingsButton={setSettingsButton}
                  />
                </div>
              ) : (
                <PageLoading customHeight={"350px"} />
              )}
            </div>
            <div className="advisor-footer-container">
              <div className="button-footer-container">
                <div className="advanced-settings-btn">{settingsButton}</div>
                <div>
                  <DupontButton
                    type="tertiary"
                    onClick={handleBack}
                    // disabled={activeStep === 0}
                  >
                    {activeStep === 0 ? (
                      <Link
                        to={`${basePath}Home?plantId=${plantId}`}
                        className="dupont-btn__tertiary--primary "
                      >
                        &lt; {t("ValueStrings.back")}
                      </Link>
                    ) : (
                      ` < ${t("ValueStrings.back")}`
                    )}
                  </DupontButton>
                  <DupontButton
                    type="tertiary"
                    onClick={handleNext}
                    disabled={
                      (activeStep === 2 || activeStep === 4) &&
                      disableNextButton
                    }
                  >
                    {renamingText} &gt;
                  </DupontButton>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )}
      {activeStep === 5 && <LifetimeAdvisorHome />}
    </>
  );
};

export default RoAdvisorHome;
